import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'submit']

  connect() {
    this.inputTarget.addEventListener('input', this.handleInput.bind(this))
  }

  disconnect() {
    this.inputTarget.removeEventListener('input', this.handleInput.bind(this))
  }

  handleInput(event) {
    const query = event.target.value || ''

    this.submitTarget.disabled = query.trim().length === 0
  }
}
